import { useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import MerchantPaymentsService from '../../../services/MerchantPaymentsService';
import { useLoaderContext } from '../../../contexts/Loader/LoaderContext';
import { getDateTime } from '../../../Utils/formats';

export const useQueryOrders = ({ storeId = '', enabled = false }) => {
  const { setIsLoaderOpen } = useLoaderContext();
  const [lastSync, setLastSync] = useState('');
  const [filters, setFilters] = useState({
    storeId: storeId,
    search: '',
    page: 1,
    pageSize: 20,
  })

  const fetchTransactions = async ({ pageSize, ...rest }) => {
    setIsLoaderOpen(true);

    let parameters = { ...rest, limit: pageSize };

    const respose =
      await MerchantPaymentsService().getOrders(parameters);

    setLastSync(getDateTime(new Date()));
    setIsLoaderOpen(false);
    return respose;
  };

  const queryResult = useQuery({
    queryKey: ['orders', filters],
    queryFn: async () => fetchTransactions(filters),
    placeholderData: keepPreviousData,
    enabled: enabled
  });

  const onUpdateFilters = newFilters => {
    setFilters(newFilters);
  };

  const onChangePage = page => {
    setFilters({ ...filters, page: Number(page) });
  };

  return {
    filters: filters,
    lastSync: lastSync,
    updateFilters: onUpdateFilters,
    changePage: onChangePage,
    queryResult: queryResult,
  };
};
